import config from "@/config";
import { routes, routesSetting } from "@/router";
import { useTranslation } from "react-i18next";
import {
  HiArrowDownTray,
  HiCog8Tooth,
  HiListBullet,
  HiMagnifyingGlass,
  HiOutlineCog8Tooth,
  HiOutlineListBullet,
  HiOutlineMagnifyingGlass,
  HiOutlineQuestionMarkCircle,
  HiOutlineSparkles,
  HiQuestionMarkCircle,
  HiSparkles,
} from "react-icons/hi2";
import { Link } from "react-router-dom";

import Logo from "@/components/atoms/Logo";
import SidebarLinkItem from "@/components/atoms/SidebarLinkItem";
import ProfilePopover from "@/components/organisms/ProfilePopover";

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div
      className={
        "sticky top-0 flex h-screen max-w-[84px] flex-col items-center justify-between border-r border-secondary bg-secondary px-2 py-4"
      }
    >
      <div className={"flex flex-col items-center justify-between gap-x-2 gap-y-2"}>
        <Link to={routes.search} className={"mb-2"}>
          <Logo className={"size-8"} />
        </Link>
        <SidebarLinkItem
          label={t("sidebar.search")}
          activeIcon={HiMagnifyingGlass}
          inactiveIcon={HiOutlineMagnifyingGlass}
          link={routes.search}
        />
        <SidebarLinkItem
          label={t("sidebar.enrich")}
          activeIcon={HiArrowDownTray}
          inactiveIcon={HiArrowDownTray}
          link={routes.enrich}
        />
        <SidebarLinkItem
          label={t("sidebar.lists")}
          activeIcon={HiListBullet}
          inactiveIcon={HiOutlineListBullet}
          link={routes.lists}
        />
        <SidebarLinkItem
          label={t("sidebar.generate")}
          activeIcon={HiSparkles}
          inactiveIcon={HiOutlineSparkles}
          link={routes.predictive}
        />
      </div>

      <div className={"flex flex-col items-center justify-between gap-2"}>
        <SidebarLinkItem
          label={t("sidebar.settings")}
          activeIcon={HiCog8Tooth}
          inactiveIcon={HiOutlineCog8Tooth}
          link={routesSetting.plans}
        />
        <SidebarLinkItem
          label={t("sidebar.help")}
          activeIcon={HiQuestionMarkCircle}
          inactiveIcon={HiOutlineQuestionMarkCircle}
          link={config.HELP_PAGE_URL}
        />

        <div className={"my-1 h-px w-full bg-quaternary"} />

        <ProfilePopover />
      </div>
    </div>
  );
};

export default Sidebar;
